// extracted by mini-css-extract-plugin
export default {"videoList":"video-list__videoList--3dmzG"};